function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
import { useTransition, a, config } from '@react-spring/web';
import "./ripple.style.scss";
const getCoordinateDistance = (a, b) => Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
const getRippleRadius = (origin, rect) => {
  const topLeft = {
    x: rect.left,
    y: rect.top
  };
  const topRight = {
    x: rect.left + rect.width,
    y: rect.top
  };
  const bottomRight = {
    x: rect.left + rect.width,
    y: rect.top + rect.height
  };
  const bottomLeft = {
    x: rect.left,
    y: rect.top + rect.height
  };
  return Math.max(getCoordinateDistance(origin, topLeft), getCoordinateDistance(origin, topRight), getCoordinateDistance(origin, bottomRight), getCoordinateDistance(origin, bottomLeft));
};
export const Ripple = props => {
  const {
    color,
    colorClassName,
    disabled
  } = props;
  const ref = React.useRef(null);
  const [visible, setVisible] = React.useState(false);
  const [{
    x,
    y
  }, setPosition] = React.useState({
    x: 0,
    y: 0
  });
  const [size, setSize] = React.useState(0);
  const ignoreMouseEvents = React.useRef(false);
  const start = React.useCallback(e => {
    if (!ref.current || e.type === 'mousedown' && ignoreMouseEvents.current) {
      return;
    }
    if (e.type === 'touchstart') {
      ignoreMouseEvents.current = true;
    }
    const rect = ref.current.getBoundingClientRect();
    const clientX = e.clientX || e.touches[0].clientX;
    const clientY = e.clientY || e.touches[0].clientY;
    const originX = clientX - rect.left;
    const originY = clientY - rect.top;
    setPosition({
      x: originX,
      y: originY
    });
    setSize(getRippleRadius({
      x: clientX,
      y: clientY
    }, rect) * 2);
    setVisible(true);
  }, [setPosition, setSize, setVisible]);
  const stop = () => setVisible(false);
  const commonProps = {
    top: `calc(${y}px - ${size / 2}px)`,
    left: `calc(${x}px - ${size / 2}px)`,
    width: size,
    height: size
  };
  const transitions = useTransition(visible, {
    from: _objectSpread({
      opacity: 0.1,
      transform: 'scale(0)'
    }, commonProps),
    enter: _objectSpread({
      opacity: disabled ? 0 : 0.3,
      transform: disabled ? 'scale(0)' : 'scale(1)'
    }, commonProps),
    leave: _objectSpread({
      opacity: 0,
      transform: 'scale(1)'
    }, commonProps),
    config: config.default
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      overflow: 'hidden'
    },
    onMouseDown: start,
    onMouseOut: stop,
    onMouseUp: stop,
    onTouchStart: start,
    onTouchEnd: stop
  }, transitions((styles, item) => item && /*#__PURE__*/React.createElement(a.div, {
    className: colorClassName,
    style: _objectSpread({
      transformOrigin: '50% 50%',
      position: 'absolute',
      backgroundColor: colorClassName ? undefined : color || '#fff',
      borderRadius: '50%',
      pointerEvents: 'none',
      userSelect: 'none'
    }, styles)
  }))));
};